import { Brand } from "@/components/Brand";

export const Layout = ({ children }) => (
    <div className="flex min-h-screen flex-col bg-slate-50">
        <header className="sticky top-0 z-30 border-b border-slate-200 bg-white/90 backdrop-blur">
            <div className="mx-auto flex max-w-6xl items-center justify-between px-6 py-3.5">
                <Brand />
                <span className="font-mono text-xs uppercase tracking-widest text-slate-400">
                    Explainer studio
                </span>
            </div>
        </header>

        <main className="mx-auto w-full max-w-6xl flex-1 px-6 py-10">
            {children}
        </main>

        <footer className="border-t border-slate-200 bg-white">
            <div className="mx-auto max-w-6xl px-6 py-6 text-xs text-slate-400">
                <p className="max-w-xl leading-relaxed">
                    Standalone animated explainer. Synthetic content only — no real
                    financial assets, custody, settlement or customer data.
                </p>
            </div>
        </footer>
    </div>
);
